export const NB_ITEM_LOAD_MORE = 20;
